import { Cell, Label, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { useEffect, useState } from "react";
import { statusConfig, StatusConfigProps } from "../../Mock";
import { useTranslation } from "react-i18next";

interface GraficoPieProps {
    tarefasValue: any;
};

export default function GraficoPie({ tarefasValue }: GraficoPieProps) {
    const { t } = useTranslation();
    const [animate, setAnimate] = useState<boolean>(false);

    const statusFilter = statusConfig(t)?.map((item: StatusConfigProps) => {
        const filterStatus = tarefasValue?.filter((itemFilter: any) => item?.status === itemFilter?.status);

        return {
            name: item?.name,
            color: item?.color,
            status: item?.status,
            value: filterStatus?.length ?? 0,
            bgColor: item?.bgColor
        }
    });

    const grandTotal = statusFilter?.reduce((acc: number, curr: any) => acc + curr?.value, 0);
    const reunioesWithPercentage = statusFilter?.map((item: any) => ({ ...item, percentage: (item?.value > 0) ? ((item?.value / grandTotal) * 100).toFixed(2) : 0, }));

    const renderTooltipContent = ({ active, payload }: any) => {
        if (active && payload && payload?.length) {
            const { name, value, percentage } = payload[0]?.payload;
            return (
                <div
                    style={{
                        backgroundColor: "#fff",
                        padding: "5px",
                        border: "1px solid #ccc",
                    }}
                >
                    <p>{t("tasks.stats.name")}: {name}</p>
                    <p>{t("tasks.stats.qty")}: {value}</p>
                    <p>{t("tasks.stats.percentage")}: {percentage}%</p>
                </div>
            );
        }
        return null;
    };

    useEffect(() => {
        const timeout = setTimeout(() => setAnimate(true), 100);
        return () => clearTimeout(timeout);
    }, []);

    return (
        <div className="w-full h-full flex flex-col justify-center items-center relative">
            <div className="w-full">
                <ResponsiveContainer width="100%" height={200}>
                    <PieChart>
                        <Pie
                            dataKey="value"
                            startAngle={360}
                            endAngle={0}
                            data={reunioesWithPercentage}
                            cx="50%"
                            cy="50%"
                            innerRadius={40}
                            outerRadius={70}
                            fill="#8884d8"
                            stroke="none"
                        >
                            <Label
                                position="center"
                                content={({ viewBox }) => {
                                    if (!viewBox || !("cx" in viewBox) || !("cy" in viewBox)) return null;
                                    const { cx, cy }: any = viewBox;
                                    return (
                                        <g>
                                            <text
                                                x={cx}
                                                y={cy - 5}
                                                textAnchor="middle"
                                                fontSize={18}
                                                fontWeight="500"
                                                fill="#000"
                                            >
                                                {tarefasValue?.length ?? 0}
                                            </text>
                                            <text
                                                x={cx}
                                                y={cy + 15}
                                                textAnchor="middle"
                                                fontSize={14}
                                                fill="#0000004D"
                                            >
                                                {t("tasks.labels.tasks")}
                                            </text>
                                        </g>
                                    );
                                }}
                            />
                            {statusFilter?.map((entry: any, index: number) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Pie>
                        <Tooltip content={renderTooltipContent} />
                    </PieChart>
                </ResponsiveContainer>
                <div className="w-full flex flex-col gap-2 pt-5">
                    {
                        reunioesWithPercentage?.map((item: any, index: number) => (
                            <div
                                key={index}
                            >
                                <p className="text-sm text-black font-medium">
                                    {item?.name}
                                </p>
                                <div
                                    className="bg-[#0000000D] relative w-full rounded-full">
                                    <div
                                        className={`font-medium text-xs text-white rounded-full px-2 ${item?.bgColor} transition-all duration-500 ease-in-out`}
                                        style={{
                                            width: animate ? `${item?.percentage}%` : "0%",
                                        }}
                                    >
                                        <p className="w-full text-end">
                                            {item?.percentage ?? 0}%
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}